<template>
	<div class="badge-label">
		{{ text }}
	</div>
</template>

<script lang="ts" setup>
	defineProps({
		text: {
			type: String,
			required: true
		}
	});
</script>

<style scoped>
	.badge-label {
		color: var(--color-grey-300);
		font-weight: normal;
		font-size: var(--badge-label-font-size, var(--font-size-p-1));
		line-height: var(--line-height-p-1);
		padding: 0 0 4px;
		margin: 0;
	}
</style>
